import { render, staticRenderFns } from "./UserAuthorizationModalLayout.vue?vue&type=template&id=23a9cbc2&"
import script from "./UserAuthorizationModalLayout.vue?vue&type=script&lang=js&"
export * from "./UserAuthorizationModalLayout.vue?vue&type=script&lang=js&"
import style0 from "./UserAuthorizationModalLayout.vue?vue&type=style&index=0&id=23a9cbc2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23a9cbc2')) {
      api.createRecord('23a9cbc2', component.options)
    } else {
      api.reload('23a9cbc2', component.options)
    }
    module.hot.accept("./UserAuthorizationModalLayout.vue?vue&type=template&id=23a9cbc2&", function () {
      api.rerender('23a9cbc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/UserAuthorization/components/common/UserAuthorizationModalLayout.vue"
export default component.exports